import React from "react";

const GridTwo = () => {
    return(
        <div className="item-two">
            <div class="insights">
                <h1>Transform your brand</h1>
                <p>We are a full-service creative agency specializing in helping brands grow fast. Engage your clients through compelling visuals that do most of the marketing for you</p>
                <a href="#">Learn More</a>
            </div>
        </div>
    )
}

export default GridTwo;